import _ from 'lodash';
import { Action } from 'redux';
import { getQueryParameter } from '../iwRouter/LocationHelper';

export function isModalOpenInURL(location: Location, id: string) {
    const modalParameter = getQueryParameter(location, 'modal');
    return modalParameter === id;
}

export function isModalLoadedAction(action: { type: string }) {
    return /modals\/.+ \[done\]/.test(action.type);
}

export function serialiseModalErrorData(action: Action[]) {
    return {
        modalID: _.get(action, 'id')
    };
}

export function getOpenModalActionName(action: { extra: string }) {
    const modalName = _.get(action, 'id', '');
    const modalExtras = action.extra ? `_${action.extra}` : '';
    const fullModalName = getMacroCase(`${modalName}${modalExtras}`);

    return `modals/OPEN_${fullModalName} [done]`;
}

function getMacroCase(text: string) {
    return text
        .replace(
            /([^A-Z_])([A-Z])/g,
            (allMatch: any, beforeCapital: any, toCapitalise: any) =>
                `${beforeCapital}_${toCapitalise}`
        )
        .toUpperCase();
}
